import { jsxs as t, Fragment as s, jsx as o } from "react/jsx-runtime";
import { u as e } from "./index-6a632112.mjs";
import { s as a, r as d } from "./themes-5f0b3c3d.mjs";
import { C as n } from "./ChildrenCountCheck-60cafda6.mjs";
import "react";
const c = 4, m = e.div`
  display: flex;
  flex-direction: row;
  gap: ${a["6x"]};
  height: max-content;
  width: 100%;
`, p = e.div`
  border-radius: ${d["2x"]};
  box-shadow: 0 2px ${a["2x"]} 0 rgba(0, 0, 0, 0.1);
  width: 100%;
  box-sizing: border-box;
  border: 1px solid
    ${(r) => r.theme.components.raisedSurface.borderColor};
  background-color: ${(r) => r.theme.components.raisedSurface.backgroundColor};
`, x = ({ children: r, className: i }) => /* @__PURE__ */ t(s, { children: [
  /* @__PURE__ */ o(
    n,
    {
      children: r,
      componentName: "Raised Surface",
      maxChildren: c
    }
  ),
  /* @__PURE__ */ o(m, { className: i, children: r })
] });
x.Container = p;
export {
  x as RaisedSurface
};
